var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25C1.8125 25 1.22396 24.7552 0.734375 24.2656C0.244792 23.776 0 23.1875 0 22.5V5C0 4.3125 0.244792 3.72396 0.734375 3.23438C1.22396 2.74479 1.8125 2.5 2.5 2.5H3.75V1.25C3.75 0.895833 3.86979 0.598958 4.10938 0.359375C4.34896 0.119792 4.64583 0 5 0C5.35417 0 5.65104 0.119792 5.89062 0.359375C6.13021 0.598958 6.25 0.895833 6.25 1.25V2.5H16.25V1.25C16.25 0.895833 16.3698 0.598958 16.6094 0.359375C16.849 0.119792 17.1458 0 17.5 0C17.8542 0 18.151 0.119792 18.3906 0.359375C18.6302 0.598958 18.75 0.895833 18.75 1.25V2.5H20C20.6875 2.5 21.276 2.74479 21.7656 3.23438C22.2552 3.72396 22.5 4.3125 22.5 5V22.5C22.5 23.1875 22.2552 23.776 21.7656 24.2656C21.276 24.7552 20.6875 25 20 25H2.5ZM2.5 22.5H20V10H2.5V22.5ZM2.5 7.5H20V5H2.5V7.5Z",
    fill: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarr);
export default __webpack_public_path__ + "static/media/calendarr.ef51fff85c03c6f0b2f67931f7a27e71.svg";
export { ForwardRef as ReactComponent };